function landingReveal() {
    $('#splash #sidebar-logos .logo-left').delay( 2000 ).animate({ top: "0"
    }, { duration: 1500, queue: false }); 
    $('#splash #sidebar-logos .logo-left').delay( 2500 ).animate({ opacity: 1
    }, { duration: 1000, queue: false }); 
    $('#splash #sidebar-logos .logo-right').delay( 2000 ).animate({ top: "0"
    }, { duration: 1500, queue: false }); 
    $('#splash #sidebar-logos .logo-right').delay( 2500 ).animate({ opacity: 1
    }, { duration: 1000, queue: false }); 

    var aspect = $(window).width() / $(window).height();
    if (aspect >= 1) {
        $('#splash #landscape').delay( 3500 ).fadeIn( 2000 );
    }
    else if (aspect < 1) {
        $('#splash #portrait').delay( 3500 ).fadeIn( 2000 );
    }
    
}

// Function to get image orientation & wrap images on PDP

function wrapImages() {

    $('.product-image').each(function(index) {
        var currentImg = $(this);
        if (currentImg.width() > currentImg.height()){
            //it's a landscape
            // currentImg.wrap( "<div class='col-xs-8 col-sm-6'><div class='ratio-16-to-9'></div></div>" );
            currentImg.wrap( "<div class='col-xs-8 col-sm-6'></div>" );
        } else if (currentImg.width() < currentImg.height()){

            //it's portrait
            if (index == 0){
                currentImg.wrap( "<div class='col-xs-8 col-sm-3'></div>" );
            }
            else {
                currentImg.wrap( "<div class='col-xs-8 col-sm-3'></div>" );
            }
            
        } else {
            //image width and height are equal, therefore it is square.
            // currentImg.wrap( "<div class='col-xs-8 col-sm-6'><div class='ratio-'></div></div>" );
            currentImg.wrap( "<div class='col-xs-8 col-sm-6'></div>" );
        }

        currentImg.css( "display", "inline" );

    });


}

$(window).on('load', function(){
    wrapImages();



});


$(document).ready(function() {

    // NEWSLETTER
    // var popup = document.getElementById("newsletter");

    // if (sessionStorage.getItem('popup_clicked') === null) {
    //     popup.style.display = "inline";
    // } else 
    // {
    //     popup.style.display = "none";
    // }

    // $('#closePopup').on('click', function () {

    //     popup.style.display = "none";
    //     sessionStorage.setItem('popup_clicked', true);
    // });

    var clipH = $('.feature-image img').height();
    var clipW = $('.feature-image img').width();
    $(".clip-wrapper").width(clipW).height(clipH);

    $( window ).resize(function() {
        var clipH = $('.feature-image img').height();
        var clipW = $('.feature-image img').width();
        $(".clip-wrapper").width(clipW).height(clipH);
        var aspect = $(window).width() / $(window).height();

        if (aspect >= 1) {
            $('#splash #landscape').show();
            $('#splash #portrait').hide();
        }
        else if (aspect < 1) {
            $('#splash #portrait').show();
            $('#splash #landscape').hide();
        }

    });

    landingReveal();


// Scroll listener
$( window ).scroll(function() {

    menuReveal();
    document.body.style.setProperty('--scroll',window.pageYOffset / window.innerHeight);

});

$.fn.exists = function () {
    return this.length !== 0;
}

function menuReveal() {

    $( "#shopify-section-header .nav-wrapper" ).show().delay( 2200 ).fadeOut(800);


}

$('#header-bumper').on('mouseenter', function () {
    $( "#shopify-section-header .nav-wrapper" ).show();
});

$('#header-bumper').on('mouseleave', function () {
    $( "#shopify-section-header .nav-wrapper" ).delay( 2200 ).fadeOut(800);
});

//Glider functions 
    document.querySelector('.glider').addEventListener('glider-slide-visible', function(event){
        var glider = Glider(this);
        console.log('Slide Visible %s', event.detail.slide)
    });
    document.querySelector('.glider').addEventListener('glider-slide-hidden', function(event){
        console.log('Slide Hidden %s', event.detail.slide)
    });
    document.querySelector('.glider').addEventListener('glider-refresh', function(event){
        console.log('Refresh')
    });
    document.querySelector('.glider').addEventListener('glider-loaded', function(event){
        console.log('Loaded')
    });

    window._ = new Glider(document.querySelector('.glider'), {
        slidesToShow: 'auto',
        slidesToScroll: 1,
        draggable: true,
        scrollLock: true,
        dots: '#dots',
        rewind: true,
        arrows: {
            prev: '.glider-prev',
            next: '.glider-next'
        },
        responsive: [
            {
                breakpoint: 480,
                settings: {
                    slidesToScroll: 'auto',
                    slidesToShow: 'auto'
                }
            }
        ]
    });





});






